import { Injectable, inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import Keycloak from 'keycloak-js';
import { type Observable, of } from 'rxjs';
import { Organizations } from '../organizations';

@Injectable({ providedIn: 'root' })
export class OrganizationRouteGuard {
  private readonly authService = inject(Keycloak);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const userProfile = this.authService.tokenParsed;

    const organizations = Object.values(Organizations);
    return of(
      organizations.some((org) => userProfile?.organization?.includes(org)),
    );
  }
}
